import * as React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { checkAuth, loadMember } from '../../utils/auth'
import Title from '../../components/ui/title/title'
import ContributionUploader from '../../components/contribution/upload/uploader'

import { RootState } from '../../store/rootReducer'

import usePageLoaded from '../../hooks/usePageLoaded'
import { getPrefixFromPath } from '../../i18next'
import paths from '../../paths'
import './contribution.sass'

const SubmitContribution: React.FunctionComponent = () => {
    usePageLoaded()
    const [t] = useTranslation()
    const { pendingMaterials } = useSelector((state: RootState) => state.contributions)
    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Title text={t('Submit your contribution')} />
            <div className="pageRow">
                <Title text={t('Upload your photos and video')} secondary />
                <div className="counter">
                    {pendingMaterials.length} {t('of 12')}
                </div>
            </div>
            <ContributionUploader />
        </div>
    )
}

// @ts-ignore
SubmitContribution.getInitialProps = async ({ req, store }) => {
    await checkAuth(store)
    const {
        member: { loggedIn }
    } = store.getState()

    if (loggedIn) {
        await loadMember(store)
    } else {
        return {
            redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${paths.submitContribution.path}`
        }
    }
}

export default SubmitContribution
